import { Controller } from "@hotwired/stimulus"
import { setSelectedValues } from "../../shared/multi_select"

export default class extends Controller {
  static values = {
    allowRefresh: Boolean,
  }

  connect() {
    this.sentCustom = document.getElementById("select-sent-invoice-org-custom")
    this.billedCustom = document.getElementById("select-be-billed-org-custom")
    this.sentCustomChanged = this.sentCustomChanged.bind(this)
    this.billedCustomChanged = this.billedCustomChanged.bind(this)
    this.sentCustom?.addEventListener("change", this.sentCustomChanged)
    this.billedCustom?.addEventListener("change", this.billedCustomChanged)
  }

  disconnect() {
    this.sentCustom?.removeEventListener("change", this.sentCustomChanged)
    this.billedCustom?.removeEventListener("change", this.billedCustomChanged)
  }

  sentCustomChanged(event) {
    if (!this.allowRefreshValue || !event.target.value) return

    this.allowRefreshValue = false
    const url = new URL("/financial_analysis/production_value_bonus_invoices/sent_invoice_org_change", window.location.origin)
    url.searchParams.set("sent_invoice_org_code", event.target.value)
    url.searchParams.set("year_name", document.getElementById("year_name")?.value || "")
    $.ajax(url.toString(), { dataType: "script" })
  }

  billedCustomChanged(event) {
    if (!this.allowRefreshValue || !event.target.value) return

    this.allowRefreshValue = false
    const url = new URL("/financial_analysis/production_value_bonus_invoices/be_billed_org_change", window.location.origin)
    url.searchParams.set("be_billed_org_code", event.target.value)
    url.searchParams.set("year_name", document.getElementById("year_name")?.value || "")
    $.ajax(url.toString(), { dataType: "script" })
  }

  swapOrgCustom() {
    const sent = $('#select-sent-invoice-org-custom').val();
    const billed = $('#select-be-billed-org-custom').val();
    this.allowRefreshValue = true;

    setSelectedValues(document.getElementById("select-sent-invoice-org-custom"), billed)
    setSelectedValues(document.getElementById("select-be-billed-org-custom"), sent)
  }

  swapOrg() {
    const sent = $('#select-sent-invoice-org').val();
    const billed = $('#select-be-billed-org').val();
    this.allowRefreshValue = true;

    setSelectedValues(document.getElementById("select-sent-invoice-org"), billed)
    setSelectedValues(document.getElementById("select-be-billed-org"), sent)
  }
}
